import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';

import { useFetchVideoCompilations } from '../../../hooks';
import { formatDateMmDdYyyy } from '../../../utils';
import { StyledTableRow } from './styles';
import VpVideoCompilationInfoMenu from './VpVideoCompilationsInfoMenu';
import { getIsOrganizationViewer } from '../../../redux/modules/organization';
import VideoCompilationPageSwitch from './VideoCompilationPageSwitch';
import { LastReceived } from '../../components';

export const VpVideoCompilationsTableBody = withRouter(({ history, isOrgViewer }) => {
  const { data } = useFetchVideoCompilations();
  const videoCompilationList = data?.records;

  const handleRowClick = (pageLink) => {
    history.push(`/compilation/${pageLink}`);
  };

  return (
    <TableBody>
      {videoCompilationList?.map((videoCompilation) => (
        <StyledTableRow
          hover
          key={videoCompilation?.id}
          onClick={() => handleRowClick(videoCompilation?.pageLink)}
        >
          <TableCell>
            <VideoCompilationPageSwitch
              enabled={videoCompilation?.enabled}
              data={videoCompilation}
              disabled={isOrgViewer}
            />
          </TableCell>
          <TableCell>{videoCompilation?.title}</TableCell>
          <TableCell>{videoCompilation?.campaignName}</TableCell>
          <TableCell>{videoCompilation?.linkClicks}</TableCell>
          <TableCell>{formatDateMmDdYyyy(videoCompilation.createdAt)}</TableCell>
          <TableCell>
            <LastReceived lastReceived={videoCompilation.lastReceived} />
          </TableCell>
          <TableCell padding="checkbox">
            {!isOrgViewer && (
              <VpVideoCompilationInfoMenu
                vcpId={videoCompilation?.id}
                pageLink={videoCompilation?.pageLink}
              />
            )}
          </TableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  );
});

const mapStateToProps = (state) => ({
  isOrgViewer: getIsOrganizationViewer(state)
});

export default connect(mapStateToProps)(VpVideoCompilationsTableBody);



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsTableBody.jsx